/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'

const Gallery = ({
    children, title, subheading, bylineCopy,bylineCopy2,bylineCopy3
}) => (
    <div className="intro-wrapper" id="intro">
        <div className="intro-titles">
            <img src={title} alt="NFT Gallery" />
            <h2>{title}</h2>
            { subheading ? <h3 className="intro-subheader">{subheading}</h3> : ''}

            { bylineCopy ? <p className="intro-byline-copy">{bylineCopy}</p> : ''}
            { bylineCopy2 ? <p className="intro-byline-copy">{bylineCopy2}</p> : ''}
            { bylineCopy3 ? <p className="intro-byline-copy">{bylineCopy3}</p> : ''}
        </div>

        <div className="intro-gallery">
            {children}
        </div>
    </div>
)

Gallery.defaultProps = {
    subheading: null,
    bylineCopy: null,
    bylineCopy2: null,
    bylineCopy3: null
}

Gallery.propTypes = {
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string.isRequired,
    subheading: PropTypes.string,
    bylineCopy: PropTypes.string,
    bylineCopy2: PropTypes.string,
    bylineCopy3: PropTypes.string,
}

export default Gallery
